import React from 'react';
import {Bell} from "lucide-react";

export interface NotificationItem {
    id: string;
    message: string;
}

interface NotificationsDropdownProps {
    notifications: NotificationItem[];
}

export const NotificationsDropdown: React.FC<NotificationsDropdownProps> = ({notifications}) => (
    <div
        className="absolute right-0 top-[calc(100%+8px)] w-80 max-w-[90vw] bg-surface border border-border rounded-2xl shadow-lg z-50 p-4 animate-fade-in-down animate-duration-200"
    >
        <div className="flex items-center gap-2 mb-3">
            <Bell size={16} className="text-ink-muted"/>
            <h2 className="text-sm font-display font-bold text-ink">Notifications</h2>
        </div>

        {notifications.length === 0 ? (
            <div className="flex flex-col items-center justify-center text-center py-8">
                <div className="size-10 rounded-xl bg-surface-sunken flex items-center justify-center mb-3">
                    <Bell size={18} className="text-ink-faint"/>
                </div>
                <p className="text-sm text-ink-muted">No notifications</p>
            </div>
        ) : (
            <ul className="space-y-2 max-h-80 overflow-y-auto">
                {notifications.map(notification => (
                    <li key={notification.id} className="text-sm text-ink-muted bg-surface-sunken rounded-lg p-3">
                        {notification.message}
                    </li>
                ))}
            </ul>
        )}
    </div>
);
